import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IOperativeUserRole } from '@app/interfaces';
import { UserService } from '@app/services/user/user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Permissions } from '@app/infrastructure/permission/permission.model';

@Injectable({ providedIn: 'root' })
export class PermissionServiceReworked {
	private readonly _permissions$: BehaviorSubject<Permissions[]> = new BehaviorSubject<Permissions[]>([]);

	public get permissions$(): Observable<Permissions[]> {
		return this._permissions$.asObservable();
	}

	public get permissions(): Permissions[] {
		return this._permissions$.value;
	}

	constructor(private router: Router, private userService: UserService) {}

	public handlePermissions(permissionMap: { [key in Permissions]: boolean }): void {
		const permissions = this.mapPermissions(permissionMap);
		// @Todo: uncomment when switch to close-mode by default
		// if (!permissions?.length) {
		//   this.redirectToAccessDenied();
		// }

		this.setPermissions(permissions);
	}

	public hasPermission$(requiredPermissions: Permissions[] = []): Observable<boolean> {
		return this.permissions$.pipe(
			map((deniedPermissions) => {
				if (requiredPermissions.length === 0) {
					return true;
				}

				if (this.userService.userRole === IOperativeUserRole.admin) {
					return true;
				}

				return requiredPermissions.every((permission) => !deniedPermissions.includes(permission));
			}),
		);
	}

	public hasPermission(requiredPermissions: Permissions[]): boolean {
		if (this.userService.userRole === IOperativeUserRole.admin) {
			return true;
		}

		return !this.isMatch(requiredPermissions, this.permissions);
	}

	private mapPermissions(permissionMap: { [key in Permissions]: boolean }): Permissions[] {
		return Object.keys(permissionMap) as Permissions[];
	}

	private setPermissions(permissions: Permissions[]): void {
		this._permissions$.next(permissions);
	}

	private isMatch(requiredItems: Permissions | Permissions[], existedItems: Permissions[]): boolean {
		return (Array.isArray(requiredItems) ? requiredItems : [requiredItems]).some((requiredItem: Permissions) =>
			existedItems.includes(requiredItem),
		);
	}

	private redirectToAccessDenied(): void {
		void this.router.navigate(['forbidden']);
	}
}
